(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["subscription-configurator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('subscription-configurator')) {
    customElements.define('subscription-configurator', class extends HTMLElement {
      connectedCallback() {
        this.steps = ['product', 'flow', 'interval', 'result'];
        this.state = { category: null, flow: null, interval: this.dataset.recommendedInterval, addons: [] };
        this.errorEl = this.querySelector('[data-error]');
        this.introEl = this.querySelector('[data-step="intro"]');
        this.containerEl = this.querySelector('[data-config-container]');

        const cellsScript = this.querySelector('[data-cells]');
        try {
          this.cells = cellsScript ? JSON.parse(cellsScript.textContent) : [];
        } catch (e) {
          this.cells = [];
          console.error('subscription-configurator: failed to parse cells', e);
        }

        this.bindEvents();
        this.applyInitialInterval();
        if (this.introEl) {
          this.showIntro();
        } else {
          this.goToStep(0, false);
        }
      }

      showIntro() {
        if (this.introEl) this.introEl.hidden = false;
        if (this.containerEl) this.containerEl.hidden = true;
      }

      startFromIntro() {
        if (this.introEl) this.introEl.hidden = true;
        if (this.containerEl) this.containerEl.hidden = false;
        this.goToStep(0);
      }

      bindEvents() {
        this.addEventListener('change', (e) => {
          if (e.target.matches('[data-category-input]')) this.setCategory(e.target.value);
          if (e.target.matches('[data-flow-input]')) this.setFlow(e.target.value);
          if (e.target.matches('[data-interval-input]')) this.setInterval(e.target.value);
        });
        this.addEventListener('click', (e) => {
          if (e.target.closest('[data-start-config]')) this.startFromIntro();
          if (e.target.closest('[data-next]')) this.next();
          if (e.target.closest('[data-prev]')) this.prev();
          if (e.target.closest('[data-submit]')) this.submit(e.target.closest('[data-submit]'));
          const addonBtn = e.target.closest('[data-addon-toggle]');
          if (addonBtn) this.toggleAddonBtn(addonBtn);
          if (e.target.closest('[data-addons-toggle]')) {
            e.preventDefault();
            const grid = this.querySelector('.sub-cfg__addons-grid');
            if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }

      applyInitialInterval() {
        const radio = this.querySelector(`[data-interval-input][value="${this.state.interval}"]`);
        if (radio) radio.checked = true;
      }

      setCategory(v) { this.state.category = v; this.updateNextBtn('product'); }
      setFlow(v) { this.state.flow = v; this.updateNextBtn('flow'); }
      setInterval(v) { this.state.interval = v; }
      toggleAddonBtn(btn) {
        const id = btn.dataset.variantId;
        const isActive = btn.hasAttribute('data-active');
        const labelEl = btn.querySelector('[data-addon-btn-label]');
        if (isActive) {
          btn.removeAttribute('data-active');
          this.state.addons = this.state.addons.filter(x => x !== id);
          if (labelEl) labelEl.textContent = btn.dataset.labelAdd || 'Lägg till';
        } else {
          btn.setAttribute('data-active', '');
          if (!this.state.addons.includes(id)) this.state.addons.push(id);
          if (labelEl) labelEl.textContent = btn.dataset.labelAdded || 'Tillagd';
        }
      }

      updateNextBtn(stepKey) {
        const step = this.querySelector(`[data-step="${stepKey}"]`);
        const btn = step && step.querySelector('[data-next]');
        if (!btn) return;
        if (stepKey === 'product') btn.disabled = !this.state.category;
        if (stepKey === 'flow') btn.disabled = !this.state.flow;
      }

      next() { this.goToStep(this.currentIdx + 1); }
      prev() { this.goToStep(this.currentIdx - 1); }

      goToStep(idx, shouldScroll = true) {
        if (idx < 0 || idx >= this.steps.length) return;
        this.currentIdx = idx;
        const key = this.steps[idx];
        this.querySelectorAll('[data-step]').forEach(s => {
          if (s.dataset.step === 'intro') return;
          s.hidden = s.dataset.step !== key;
          if (s.dataset.step === key) s.setAttribute('data-active', '');
          else s.removeAttribute('data-active');
        });
        if (key === 'result') this.renderResult();
        if (shouldScroll) {
          window.scrollTo({ top: this.getBoundingClientRect().top + window.scrollY - 100, behavior: 'smooth' });
        }
      }

      renderResult() {
        const { category, flow, interval } = this.state;
        this.querySelectorAll('[data-result-for]').forEach(el => {
          el.hidden = !(el.dataset.resultFor === category && el.dataset.resultFlow === flow);
        });
        const activeCard = this.querySelector(`[data-result-for="${category}"][data-result-flow="${flow}"]`);
        let discountPct = 0;
        if (activeCard) {
          discountPct = Number(activeCard.dataset.discount || 0);
          activeCard.querySelectorAll('[data-items-for-interval]').forEach(list => {
            list.hidden = list.dataset.itemsForInterval !== interval;
          });
          activeCard.querySelectorAll('[data-price-for-interval]').forEach(el => {
            el.hidden = el.dataset.priceForInterval !== interval;
          });
          activeCard.querySelectorAll('[data-img-for-interval]').forEach(img => {
            img.hidden = img.dataset.imgForInterval !== interval;
          });
        }
        this.updateAddonPrices(discountPct, interval);
      }

      updateAddonPrices(discountPct, interval) {
        const months = interval === 'every_3_months' ? 3 : interval === 'every_2_months' ? 2 : 1;
        this.querySelectorAll('[data-addon-card]').forEach(card => {
          const priceWrapper = card.querySelector('[data-addon-price]');
          if (!priceWrapper) return;
          const base = Number(priceWrapper.dataset.addonPrice) || 0;
          const original = Math.round(base / months);
          const discounted = Math.round(base * (100 - discountPct) / 100 / months);
          const originalEl = card.querySelector('[data-addon-price-original]');
          const currentEl = card.querySelector('[data-addon-price-current]');
          const saveEl = card.querySelector('[data-addon-save]');
          if (currentEl) currentEl.innerHTML = this.formatCents(discounted) + '/månad';
          if (discountPct > 0) {
            if (originalEl) { originalEl.innerHTML = this.formatCents(original); originalEl.hidden = false; }
            if (saveEl) { saveEl.textContent = 'spara ' + discountPct + '%'; saveEl.hidden = false; }
          } else {
            if (originalEl) originalEl.hidden = true;
            if (saveEl) saveEl.hidden = true;
          }
        });
      }

      formatCents(cents) {
        try {
          if (window.Shopify && window.Shopify.formatMoney && window.theme && window.theme.moneyFormat) {
            return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
          }
          if (window.theme && window.theme.formatMoney && window.theme.moneyFormat) {
            return window.theme.formatMoney(cents, window.theme.moneyFormat);
          }
        } catch (e) {}
        return (cents / 100).toFixed(0) + ' kr';
      }

      getSellingPlanId() {
        const radio = this.querySelector(`[data-interval-input][value="${this.state.interval}"]`);
        return radio ? radio.dataset.planId : null;
      }

      findCell() {
        const { category, flow, interval } = this.state;
        return this.cells.find(c => c.cat === category && c.flow === flow && c.interval === interval);
      }

      buildCartItems() {
        const planId = this.getSellingPlanId();
        const cell = this.findCell();
        const baseItems = (cell ? cell.items : []).map(it => ({
          id: Number(it.id),
          quantity: Number(it.qty),
          selling_plan: planId ? Number(planId) : undefined
        }));
        const addonItems = this.state.addons.map(id => ({
          id: Number(id),
          quantity: 1,
          selling_plan: planId ? Number(planId) : undefined
        }));
        return [...baseItems, ...addonItems].filter(it => it.id && it.quantity);
      }

      async submit(btn) {
        this.errorEl.hidden = true;
        const items = this.buildCartItems();
        if (!items.length) { this.showError('Ingen produkt hittades för det här valet. Kontrollera konfiguratorns inställningar i admin.'); return; }
        const planId = this.getSellingPlanId();
        if (!planId) { this.showError('Selling plan saknas för valt intervall.'); return; }
        btn.classList.add('is-loading');
        try {
          const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!res.ok) {
            const err = await res.json().catch(() => ({}));
            throw new Error(err.description || err.message || 'Kunde inte lägga i varukorgen.');
          }
          window.location.href = `${window.Shopify.routes.root}checkout`;
        } catch (err) {
          this.showError(err.message || 'Något gick fel.');
          btn.classList.remove('is-loading');
        }
      }

      showError(msg) {
        this.errorEl.textContent = msg;
        this.errorEl.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
